import {Grid} from "@mui/material";
import FreeSens from "../../assets/img/freesensLittle.svg";
import styles from "../../assets/css/Invitaion.module.css";
import Button from "@mui/material/Button";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export const InvitationErrorPage = () => {
    return (
        <Grid container>
            <img src={FreeSens} style={{margin: '24px auto 94px'}} alt='FreeSens logo'/>
            <ErrorOutlineIcon className={styles.iconError}/>
            <p className={styles.errorText}> دیگر درخواستی  به این لینک وجود ندارد! </p>
            <p className={styles.invitationText}>دکتر درخواست را حذف کرده است و یا لینک اشتباه است</p>

        </Grid>
    )
}